import {
  createResidentTask,
  deleteResidentTask,
  listResidentTasks,
  updateResidentTask,
} from "@/api/residents";
import { WorkflowTaskChecklist } from "@/components/workflow_tracking/WorkflowTaskChecklist";

type ResidentTasksProps = {
  municipalityId: number;
  residentId: number;
  onInvalidate?: () => void;
};

export function ResidentTasks({ municipalityId, residentId, onInvalidate }: ResidentTasksProps) {
  const tasksQueryKey = ["resident_tasks", municipalityId, residentId] as const;
  const timelineQueryKey = ["resident_timeline", municipalityId, residentId] as const;

  return (
    <WorkflowTaskChecklist
      testId="resident-tasks"
      heading="Tasks"
      description="Track follow-up steps for this resident."
      tasksQueryKey={tasksQueryKey}
      eventsQueryKey={timelineQueryKey}
      listTasks={() => listResidentTasks(municipalityId, residentId)}
      createTask={(payload) => createResidentTask(municipalityId, residentId, payload)}
      updateTask={(taskId, patch) =>
        updateResidentTask(municipalityId, residentId, taskId, patch)
      }
      deleteTask={(taskId) => deleteResidentTask(municipalityId, residentId, taskId)}
      onInvalidatePipeline={(queryClient) => {
        queryClient.invalidateQueries({ queryKey: timelineQueryKey });
        onInvalidate?.();
      }}
    />
  );
}
